// extracted by mini-css-extract-plugin
module.exports = {"leftContent":"_symbol__leftContent__Yy7_w","rightContent":"_symbol__rightContent__uhkHI"};